export * from './firebase.config';